import { render, staticRenderFns } from "./ListPermissoes.vue?vue&type=template&id=0773d0da"
import script from "./ListPermissoes.vue?vue&type=script&lang=js"
export * from "./ListPermissoes.vue?vue&type=script&lang=js"
import style0 from "./ListPermissoes.vue?vue&type=style&index=0&id=0773d0da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports